import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { LucideX } from '@lucide/angular';

@Component({
  selector: 'ds-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
  template: `
    <span class="tag">
      <span class="tag__label"><ng-content /></span>
      @if (dismissible()) {
        <button
          type="button"
          class="tag__dismiss"
          [attr.aria-label]="dismissLabel()"
          (click)="dismissed.emit()"
        >
          <ng-container
            [ngComponentOutlet]="closeIcon"
            [ngComponentOutletInputs]="{ size: 18, strokeWidth: 2.5 }"
          />
        </button>
      }
    </span>
  `,
  styles: `
    :host {
      display: inline-block;
    }

    .tag {
      display: inline-flex;
      align-items: center;
      gap: var(--space-1);
      min-height: 40px;
      padding: 0 var(--space-3);
      background: var(--color-bg-subtle);
      border: 1.5px solid var(--color-border);
      border-radius: var(--radius-md);
      font-size: var(--text-sm);
      color: var(--color-text);
    }

    .tag__dismiss {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      margin-right: calc(var(--space-2) * -1);
      border: 0;
      background: transparent;
      border-radius: var(--radius-full);
      cursor: pointer;
      color: var(--color-text-secondary);
      transition: background-color var(--motion-fast), color var(--motion-fast);

      &:hover {
        background: var(--color-error-tint);
        color: var(--color-error);
      }
    }
  `,
})
export class TagComponent {
  dismissible = input(false);
  dismissLabel = input('Hapus');
  dismissed = output<void>();

  protected readonly closeIcon = LucideX;
}
